import React, { useState } from "react";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { Grid, Typography, Link } from "@material-ui/core";
import { DDUConsentTable } from "./DDUConsentTable/DDUConsentTable";
import ExternalRoutes from "Shared/Constants/ExternalRoutes";
import { DPExportButton } from "Components/DP";
import mutations from "Shared/mutations";
import { useMutation } from "@apollo/client";
import { successToast, errorToast } from "Modules/DPToast";
import useStyles from "./styles";
import { ExportDduConsentReportMutation, ExportDduConsentReportMutationVariables } from "generated/graphql";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import {
  ComplianceReportLabel,
  ComplianceReportPath,
} from "../ComplianceReports";

export const DDUConsentReport = () => {
  const classes = useStyles();
  const [exportReportFn] = useMutation<ExportDduConsentReportMutation, ExportDduConsentReportMutationVariables>(
    mutations.EXPORT_DDU_CONSENT_REPORT
  );

  const [disableExportButton, setDisableExportButton] = useState(false);

  const handleExportButtonClick = async () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.ReportExportClicked,
      payload: { tab: ComplianceReportLabel[ComplianceReportPath.dduConsent] },
    });

    setDisableExportButton(true);
    try {
      const exportResponse = await exportReportFn();
      successToast(exportResponse.data!.exportDduConsentReport.message);
    } catch (e) {
      setDisableExportButton(true);
      errorToast("Failed to export report.");
    }
  };

  return (
    <Grid container spacing={2}>
      <HelpText>
        <b>What is the Direct Deposit Update Consent Report?</b> Evidence that all users signed&thinsp;
        <Link href={ExternalRoutes.termsOfUse}>
          terms of use
        </Link>
        &thinsp;(and therefore consented to direct deposit update) before using DailyPay.
      </HelpText>
      <Grid item xs={12} container justify="flex-end">
        <DPExportButton
          handleExport={handleExportButtonClick}
          disabled={disableExportButton}
          align="right"
          size="large"
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3" className={classes.tableTitle}>
          Direct Deposit Update Consent Report
        </Typography>
        <DDUConsentTable />
      </Grid>
    </Grid>
  );
};
